import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import {
    FAILURE_CREATE_PAYMENT_METHOD_ADMIN,
    FAILURE_FETCH_PAYMENT_METHODS_ADMIN,
    FAILURE_UPDATE_PAYMENT_METHOD_ADMIN,
    REQUEST_CREATE_PAYMENT_METHOD_ADMIN,
    REQUEST_FETCH_PAYMENT_METHODS_ADMIN,
    REQUEST_UPDATE_PAYMENT_METHOD_ADMIN,
    SUCCESS_CREATE_PAYMENT_METHOD_ADMIN,
    SUCCESS_FETCH_PAYMENT_METHODS_ADMIN,
    SUCCESS_UPDATE_PAYMENT_METHOD_ADMIN,
} from './actions';

export function paymentMethodAdminReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_PAYMENT_METHODS_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_PAYMENT_METHODS_ADMIN:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_PAYMENT_METHODS_ADMIN:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });

        case REQUEST_CREATE_PAYMENT_METHOD_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_PAYMENT_METHOD_ADMIN:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_CREATE_PAYMENT_METHOD_ADMIN:
            return _.assign({}, state, { isFetching: false, error: action.error });

        case REQUEST_UPDATE_PAYMENT_METHOD_ADMIN:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_PAYMENT_METHOD_ADMIN:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPDATE_PAYMENT_METHOD_ADMIN:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });

        default:
            return state;
    }
}
